// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles_faq__ZlcrK","faqInner":"styles_faqInner__IIF11","title":"styles_title__ch6HM"};